<template>
  <v-container>
    <v-row class="font-weight-bold text-caption">
      <v-col cols="6" />

      <!-- Not a field actually, just a name for column -->
      <v-col cols="3">
        {{
          $t(
            "entities.shiftModelDeduction.fields.affects_labour_shiftModelDeduction"
          )
        }}
      </v-col>
      <v-col cols="3">
        {{
          $t(
            "entities.shiftModelDeduction.fields.affects_machines_shiftModelDeduction"
          )
        }}
      </v-col>

      <v-col cols="4" />
    </v-row>
    <template v-if="shiftModel">
      <v-row>
        <v-col cols="6">
          <CalcInputNumber
            :id="props.id"
            field="technical_availability_percentage_shiftModel"
            max="100"
            min="0"
            :rules="[percents]"
            step="0.01" />
        </v-col>
        <v-col cols="3">
          <!-- at the moment hard coded <v-checkbox v-model="shiftModel.technical_availability_percentage_affects_workers" />-->
          <v-checkbox
            :model-value="affectsStaff.technical"
            @update:model-value="handleStaffChange(1)" />
        </v-col>
        <v-col cols="3">
          <!-- at the moment hard coded <v-checkbox v-model="shiftModel.technical_availability_percentage_affects_machines" />-->
          <v-checkbox
            disabled
            :model-value="affectsMachine.technical"
            @update:model-value="handleMachineChange(1)" />
        </v-col>
        <v-col cols="4" />
      </v-row>
      <v-row>
        <v-col cols="6">
          <CalcInputNumber
            :id="props.id"
            field="private_distribution_time_percentage_shiftModel"
            max="100"
            min="0"
            :rules="[percents]"
            step="0.01" />
        </v-col>
        <v-col cols="3">
          <!-- at the moment hard coded <v-checkbox v-model="shiftModel.private_distribution_time_percentage_affects_workers" />-->
          <v-checkbox
            disabled
            :model-value="affectsStaff.private"
            @update:model-value="handleStaffChange(4)" />
        </v-col>
        <v-col cols="3">
          <!-- at the moment hard coded <v-checkbox v-model="shiftModel.private_distribution_time_percentage_affects_machines" />-->
          <v-checkbox
            :model-value="affectsMachine.private"
            @update:model-value="handleMachineChange(4)" />
        </v-col>
        <v-col cols="4" />
      </v-row>
      <v-row>
        <v-col cols="6">
          <CalcInputNumber
            :id="props.id"
            field="objective_distribution_time_percentage_shiftModel"
            max="100"
            min="0"
            :rules="[percents]"
            step="0.01" />
        </v-col>
        <v-col cols="3">
          <!-- at the moment hard coded <v-checkbox v-model="shiftModel.objective_distribution_time_percentage_affects_workers" /> -->
          <v-checkbox
            disabled
            :model-value="affectsStaff.objective"
            @update:model-value="handleStaffChange(2)" />
        </v-col>
        <v-col cols="3">
          <!-- at the moment hard coded <v-checkbox v-model="shiftModel.objective_distribution_time_percentage_affects_machines" />-->
          <v-checkbox
            :model-value="affectsMachine.objective"
            @update:model-value="handleMachineChange(2)" />
        </v-col>
        <v-col cols="4" />
      </v-row>

      <!-- Formulas and calculations -->
      <div style="width: 50%">
        <CalcOutput
          :id="id"
          outside-label
          :unit="t('units.h_per_year')"
          field="staff_availability_after_deductions_shiftModel" />

        <CalcOutput
          :id="id"
          outside-label
          :unit="t('units.h_per_year')"
          field="machine_availability_after_deductions_shiftModel" />
      </div>
    </template>
  </v-container>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";
import { useSpaceStore } from "@/stores/spaceStore";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";
import { useCalculationStore } from "@/stores/calculationStore";
import CalcOutput from "@/components/Elements/CalcOutput.vue";

const { t } = useTranslation();
const spaceStore = useSpaceStore();
const calculationStore = useCalculationStore();
const { percents } = useCommonRules(t);

const shiftModel = ref(null);

const props = defineProps({
  id: {
    type: String,
    default: null
  }
});

const affectsMachine = computed(() => {
  let v =
    Number(
      shiftModel.value.affects_machine_availability_after_deductions_shiftModel
    ) || 0;
  return {
    technical: !!(v & 1),
    objective: !!(v & 2),
    private: !!(v & 4)
  };
});

const affectsStaff = computed(() => {
  let v =
    Number(
      shiftModel.value.affects_staff_availability_after_deductions_shiftModel
    ) || 0;
  return {
    technical: !!(v & 1),
    objective: !!(v & 2),
    private: !!(v & 4)
  };
});

function handleMachineChange(value) {
  calculationStore.focusElement(
    props.id,
    "affects_machine_availability_after_deductions_shiftModel"
  );
  calculationStore.changeValue(
    props.id,
    "affects_machine_availability_after_deductions_shiftModel",
    shiftModel.value.affects_machine_availability_after_deductions_shiftModel ^
      value
  );
  calculationStore.clearFocusQueue();
}

function handleStaffChange(value) {
  calculationStore.focusElement(
    props.id,
    "affects_staff_availability_after_deductions_shiftModel"
  );
  calculationStore.changeValue(
    props.id,
    "affects_staff_availability_after_deductions_shiftModel",
    shiftModel.value.affects_staff_availability_after_deductions_shiftModel ^
      value
  );
  calculationStore.clearFocusQueue();
}

onMounted(() => {
  shiftModel.value = spaceStore.getElement(props.id);
});
</script>
